// extracted by mini-css-extract-plugin
export default {"page":"HowG34n8hX2zdmSrNnpL"};